.uxn-notification-settings {
	@keyframes background-shift {
		0% {
			background-position: -400px;
		}

		100% {
			background-position: 400px;
		}
	}

	%loading-anim {
		animation: background-shift 1000ms linear infinite forwards;
		background: #ddd;
		background-image: linear-gradient(to left, #ddd 0%, #f5f5f5 20%, #e5e5e5 40%, #ddd 100%);
		background-repeat: no-repeat;
		background-size: 400px;
		position: relative;
	}

	.skeleton {
		height: 54px;

		td {
			position: relative;

			&::before {
				@extend %loading-anim;

				content: "";
				position: absolute;
				inset: 15px;
				width: calc(100% - 30px);
				height: calc(100% - 30px);
				pointer-events: none;
			}

			&.no-animation::before {
				background: #ddd;
				animation: none;
			}
		}
	}

	th,
	td {
		.ux-icon {
			margin-left: 5px;
			vertical-align: text-top;
		}

		.ux-tooltip {
			text-transform: none;
		}
	}

	.ux-button-group-spacing {
		display: flex;
		gap: 0 10px;
		align-items: center;
	}

	.asset-table-container {
		height: auto;
		max-height: 50vh;
		overflow-y: auto;

		/* hacky solution to center ux-checkbox inside the first table column (conventional centering fails because the ui.lib does not correctly remove empty labels on ux-checkbox) */
		table th:first-child > *:first-child,
		table td:first-child > *:first-child {
			margin-left: calc((100% - 20px) / 2); /* 20px is width of checkbox */
		}

		/* hacky solution to move ux-icon closer to it's parent ux-checkbox (default distance to big because the ui.lib does not correctly remove empty labels on ux-checkbox) */
		table th ux-checkbox ux-icon {
			margin-left: -4px;
		}
	}
}
